import { render, staticRenderFns } from "./codeDictModal.vue?vue&type=template&id=16050c32"
import script from "./codeDictModal.vue?vue&type=script&lang=js"
export * from "./codeDictModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports